
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import ChangeButtons from '../../../components/UI/ChangeButtons';
import { removeItemFunction } from "../AdminWrapper/RemoveItem";
import { cancelRemovingFunction } from "../AdminWrapper/CancelRemoving";

const AdminArticle = () => {

    const authUser = useSelector(x => x.auth.user);
    const articles = []
    
    const removeArticle = (currentId, artificialId) => {
        removeItemFunction(currentId, 'removingArticle', authUser)
    }

    const cancelRemovingArticle = (currentId, artificialId) => {
        cancelRemovingFunction(currentId, 'cancelDeletingArticle', authUser)
    }

    const alterArticle = (currentId, artificialId) => {

    }

    return (
        <Container fluid className='admin-decorator'>
            <div className='admin-decorator__title'>
                Статьи
            </div>
            <div className="admin__btn-group"> 
                <Link to={'/admin/home/article/newarticles'} className='admin__button'>Добавить статью</Link>
                <button className='admin__button'  type="submit">Очистить все фильтры</button>
            </div>
            <table className='admin__table'>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Название статьи</th>
                        <th>URL статьи</th>
                        <th>Дата обновления</th>
                        <th>Править или удалить</th>
                    </tr>
                    <tr id="w0-filters" className="filters">
                        <td><input type="text" className="form-control"/></td>
                        <td><input type="text" className="form-control"/></td>
                        <td>&nbsp;</td>
                        <td><input type="text" className="form-control"/></td>
                        <td>&nbsp;</td>
                    </tr>
                </thead>
                <tbody>
                {articles && articles?.map((item) => {
                    return <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                <td>{item.url}</td>
                                <td>{item.data}</td>
                                <td style={{textAlign: 'right'}}>
                                    <ChangeButtons 
                                    itemId={item.id} 
                                    removeFunction={removeArticle} 
                                    cancelFunction={cancelRemovingArticle} 
                                    alterFunction={alterArticle}
                                    itemStatus={['block', 'none', 'none']}/>
                                </td>
                            </tr>
                })}
                </tbody>
            </table>
        </Container>
    )
}

export default AdminArticle ;